import axios from "axios";

const instance = axios.create({
  baseURL: "https://dev.api.halla.in/api"
});

export default instance;
